<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiShieldOutline }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Data Privacy Statement
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- End App Bar -->
        <v-container style="width:90%; margin:auto">
            <h4>Health Maintenance, Inc. is fully compliant with the Data Privacy Act of 2012.</h4>
            <br>
            <p>
                The personal and medical information to be gathered and processed by HMI are but not limited to: name, age, address, medical history, signs and symptoms, diagnosis, diagnostic test, treatment, therapeutic procedure and medical management, utilization, name of hospital, clinic and attending physician, date and length of confinement, accommodation, and medical costs; and similar data for dependents members (collectively referred to as “Information”). The purpose is for the processing medical claims as a prospective client and member of HMI.
            </p>
            <p>
                The collection shall continue for as long as one is a client and member of HMI. The method of the processing of the data which is through collection by HMI employees with legitimate interest, licensed agents, HMI liaison officers from accredited hospitals and clinics, encoding at the computers of HMI at its Head Office, processing which will be done partly automatic; that the recipient to whom the Information shall be disclosed to are the employees of HMI or duly licensed HMI agents with legitimate interest to the said information.
            </p>
            <p>
                The personal information controller shall be HMI which can be contacted at 1152 Chino Roces Ave, San Antonio Village, Makati, 1203 and tel. no. (02)88111313. The Information shall be stored for a period of ten (10) years; and all parties agree that prospective HMI clients, and existing and past HMI members and their dependents are informed of the right to refuse to give this consent and to withdraw consent already given (right to object), right to access, correct inaccuracies, erase or block the Information or any part of it, right to data portability consisting of moving, transferring and copying of the Information securely; the right to lodge a complaint before the National Privacy Commission, as well as entitlement to damages in case of violation of our said rights, all granted and defined under R.A. 10173.
            </p>
            <p>
                For any concerns regarding the Data Privacy Policies of HMI, kindly contact our DPO:
            </p>
            <p>
                <b>Norman S. Francisco</b><br>
                Vice President For Marketing <br>
                Sales And Marketing Division <br>
                Office Numbers:  8811-1313 • 7752-0552 • 8865-3700 <br>
            </p>
        </v-container>
    <!-- Data Privacy Statement -->
    </section>
</template>

<script>
import { mdiShieldOutline } from '@mdi/js'

export default {
    data: () => ({
        mdiShieldOutline
    })
}
</script>

<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
